/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Messages_Subtitle1Inputs */

const en_coinvestments_messages_subtitle1 = /** @type {(inputs: Coinvestments_Messages_Subtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Help requests and conversations with LPs`)
};

/**
* | output |
* | --- |
* | "Help requests and conversations with LPs" |
*
* @param {Coinvestments_Messages_Subtitle1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_messages_subtitle1 = /** @type {((inputs?: Coinvestments_Messages_Subtitle1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Messages_Subtitle1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_messages_subtitle1(inputs)
});
export { coinvestments_messages_subtitle1 as "coInvestments_messages_subtitle" }